import React, { useState } from 'react'
import { useMutation } from '@apollo/client'
import { Container, Header, Form, Input, Button } from 'semantic-ui-react'
import { CREATE_TEAM_MUTATION } from '../../../graphql/team'
import { phoneValidation } from '../../../utils/helpers'

const TeamCreatePanel = ({ teams, setTeams, onCancel }) => {
    const [companyName, setCompanyName] = useState('')
    const [teamName, setTeamName] = useState('')
    const [phone, setPhone] = useState('')
    const [adminFirstName, setAdminFirstName] = useState('')
    const [adminLastName, setAdminLastName] = useState('')
    const [adminEmail, setAdminEmail] = useState('')

    const [createTeam] = useMutation(CREATE_TEAM_MUTATION)

    const onCreate = () => {
        if (!phoneValidation(phone)) {
            return alert('Invalid phone number')
        }

        createTeam({
            variables: {
                team: {
                    name: teamName,
                    company: companyName,
                    phone,
                },
                member: {
                    email: adminEmail,
                    firstName: adminFirstName,
                    lastName: adminLastName,
                },
            },
            update: (cache, { data: { createTeam } }) => {
                setTeams(teams.concat(createTeam))
                onCancel()
            },
        })
    }

    return (
        <Container className="side-panel">
            <Header size="huge" textAlign="center">
                <Header.Content>Create new team</Header.Content>
            </Header>
            <Form style={{ marginTop: '5%' }}>
                <Form.Field>
                    <Input
                        placeholder="Company name"
                        value={companyName}
                        onChange={(e, { value }) => setCompanyName(value)}
                    />
                </Form.Field>
                <Form.Field>
                    <Input
                        placeholder="Team name"
                        value={teamName}
                        onChange={(e, { value }) => setTeamName(value)}
                    />
                </Form.Field>
                <Form.Field>
                    <Input
                        placeholder="Admin first name"
                        value={adminFirstName}
                        onChange={(e, { value }) => setAdminFirstName(value)}
                    />
                </Form.Field>
                <Form.Field>
                    <Input
                        placeholder="Admin last name"
                        value={adminLastName}
                        onChange={(e, { value }) => setAdminLastName(value)}
                    />
                </Form.Field>
                <Form.Field>
                    <Input
                        placeholder="Admin email address"
                        value={adminEmail}
                        onChange={(e, { value }) => setAdminEmail(value)}
                    />
                </Form.Field>
                <Form.Field>
                    <Input
                        placeholder="Phone number (Optional)"
                        value={phone}
                        onChange={(e, { value }) => setPhone(value)}
                    />
                </Form.Field>
                <div>
                    <Button
                        primary
                        disabled={
                            !companyName ||
                            !teamName ||
                            !adminFirstName ||
                            !adminLastName ||
                            !adminEmail
                        }
                        onClick={onCreate}
                    >
                        Create team
                    </Button>
                    <Button onClick={onCancel} floated="right">
                        Cancel
                    </Button>
                </div>
            </Form>
        </Container>
    )
}

export default TeamCreatePanel
